import { REGISTRAREMPRESA } from "../Constants/Endpoinst";
import { ApiRequestInterceptor } from "./apiRequest";

export const fetchRegistrarEmpresa = async (body) => {
  const method = "POST";
  const response = await ApiRequestInterceptor(REGISTRAREMPRESA.empresa, method, body);

  if (response.code === 200 || response.code === 201) {
    localStorage.setItem("empresaRegistrada", JSON.stringify(response));
    window.dispatchEvent(new Event("empresaRegistrada"));
  } else {
    const errorMessage = response?.data?.error || "Error desconocido";
    throw new Error(errorMessage);
  }
};